interface LoadingSpinnerProps {
  fullPage?: boolean
  message?: string
}

export function LoadingSpinner({ fullPage, message }: LoadingSpinnerProps) {
  if (fullPage) {
    return (
      <div className="login-page">
        <div className="login-loading">
          <div className="login-spinner" />
          {message && <p style={{ color: 'var(--text-secondary)', margin: 0 }}>{message}</p>}
        </div>
      </div>
    )
  }

  return (
    <div className="page-loading">
      <div className="login-loading">
        <div className="login-spinner" />
        {message && <p style={{ color: 'var(--text-secondary)', margin: 0 }}>{message}</p>}
      </div>
    </div>
  )
}
